import React from 'react';
import { View, Text, Platform } from 'react-native';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import type { UIComponentContract } from '../../types/componentContract';

// Conditionally import charts only on web
let WebDonutChart: any = null;
if (Platform.OS === 'web') {
  try {
    const chartUtils = require('@utils/chartUtils/createChart');
    WebDonutChart = chartUtils.DonutChart;
  } catch (error) {
    console.warn('DonutChart not available for web');
  }
}

export const uiContract: UIComponentContract = {
  id: "chart.donut",
  accepts: {
    capability: "display_chart",
    shape: {
      series: "array",
      labels: "array",
      chartTitle: "string?",
      colors: "array?",
      height: "number?"
    },
    required: ["series", "labels"],
    optional: ["chartTitle", "colors", "height"]
  },
  renders: "chart",
  priority: 10,
  surface: "dashboard"
};

interface DonutChartProps {
  data: {
    series: number[];
    labels: string[];
    chartTitle?: string;
    colors?: string[];
    height?: number;
  };
}

export const DonutChart: React.FC<DonutChartProps> = ({ data }) => {
  const theme = themeSelector();
  const { series, labels, chartTitle = "Distribution", colors = ['#45B369', '#FF9F29', '#487FFF'], height = 300 } = data || {};

  if (Platform.OS === 'web' && WebDonutChart) {
    return (
      <View style={{ height: height }}>
        <WebDonutChart
          series={series}
          labels={labels}
          chartTitle={chartTitle}
          colors={colors}
          height={height}
        />
      </View>
    );
  }

  // Native fallback - could use react-native-chart-kit or similar
  return (
    <View style={{ height: height, justifyContent: 'center', alignItems: 'center', padding: 20 }}>
      <Text style={{ color: theme ? '#64748b' : '#94a3b8', fontSize: 14, textAlign: 'center' }}>
        Donut chart not available on this platform
      </Text>
    </View>
  );
};

// Attach contract to component
(DonutChart as any).uiContract = uiContract;

export default DonutChart;












